/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, OnInit } from '@angular/core';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class LocoStatusComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status',
  templateUrl: './loco-status.component.html',
  styleUrls: ['./loco-status.component.scss']
})
@PermitAll()
export class LocoStatusComponent implements OnInit {

  /**
   * Creates an instance of LocoStatusComponent.
   * @param {LmsLoaderService} lmsLoaderService
   * @memberOf LocoStatusComponent
   */
  constructor() {

  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LocoStatusComponent
   */
  ngOnInit() {

  }
}
